import { ref, computed } from "vue";
import { Reactions } from "@/helpers/enum";
import { ReactionType } from "../models/likepost.model";
import { onSnapshot, getFirestore, collection, query, where, Unsubscribe } from "firebase/firestore";

let unSubscribe: Unsubscribe;

export const usePostReaction = () =>
{
    let postReactions = ref<any[]>([])
    let forumReactions = ref<any[]>([])
    const selectedReaction = ref<string>("All");
    let reactions = ref<any[]>([
        {
            title: "All",
            count: 0,
        },
        {
            title: ReactionType.Like,
            icon: Reactions.like,
            count: 0,
        },
        {
            title: ReactionType.Heart,
            icon: Reactions.love,
            count: 0,
        },
        {
            title: ReactionType.Appreciated,
            icon: Reactions.blessed,
            count: 0,
        },
        {
            title: ReactionType.Kiss,
            icon: Reactions.smooch,
            count: 0,
        },
    ]);



    const filterReactions = computed(() =>
    {
        let filteredArray: any = []
        if (postReactions.value)
        {
            postReactions.value!.filter((reaction: any) =>
            {
                if (reaction.sourceType === 'post')
                {
                    if (selectedReaction.value !== "All" && reaction.reactionType === selectedReaction.value)
                    {
                        filteredArray.push(reaction)
                    }
                    if (selectedReaction.value === "All")
                    {
                        filteredArray.push(reaction)
                    }
                }
            })

        }
        return filteredArray
    })



    const countreaction = (reaction: string) =>
    {
        let count = 0
        if (postReactions.value)
        {
            for (let i = 0; i < postReactions.value.length; i++)
            {
                if (postReactions.value[i].reactionType === reaction && postReactions.value[i].sourceType === "post")
                {
                    count += 1
                    break;
                }
            }
        }
        return count;
    }


    const handleReactionsFigure = () =>
    {
        reactions.value = reactions.value.filter((item: any) =>
        {
            if (item.title === "All")
            {
                item.count = postReactions.value!.filter(x => x.sourceType === 'post').length
            } else
            {

                item.count = countreaction(item.title)
            }
            return item
        })

    }


    const handlePostreactions = async (postId: string) =>
    {
        const storage = getFirestore();

        let q = query(collection(storage, 'reactions'), where("postId", '==', postId))
        postReactions.value = []

        unSubscribe = onSnapshot(q, (querySnapshot) =>
        {
            querySnapshot.docChanges().forEach((change) =>
            {
                let data = change.doc.data();
                if (change.type === "added")
                {
                    postReactions.value.push(data);

                }
                else if (change.type === "modified")
                {

                    let index = postReactions.value.findIndex((item: any) => item._id === data._id);
                    if (index !== -1)
                    {

                        postReactions.value[index] = data;
                    }

                }
                else if (change.type === "removed")
                {
                    let index = postReactions.value.findIndex((item: any) => item._id === data._id);
                    if (index !== -1)
                    {
                        postReactions.value.splice(index, 1);
                    }

                }
                handleReactionsFigure()
            })

        });
    }

    const stopFetching = () =>
    {
        unSubscribe()
    }

    return {
        forumReactions,
        handlePostreactions,
        postReactions,
        handleReactionsFigure,
        reactions,
        selectedReaction,
        filterReactions,
        stopFetching,
    }
}